export enum DescriptionType {
  EVENT = 'event', // parties, events
  TECHNICAL_INFORMATION = 'technical_information', // issues, maintenance
  ADMINISTRATIVE_ANNOUNCEMENT = 'administrative_announcement', // new rules, changes
}

export enum MessageStyle {
  INFORMAL = 'informal', // casual, friendly
  NEUTRAL = 'neutral', // straightforward, professional
  FORMAL = 'formal', // official, respectful
}

export enum MessageLength {
  SHORT = 'short', // 2-3 sentences
  STANDARD = 'standard', // 2-3 paragraphs
  EXTENDED = 'extended', // more details but not less than 2 paragraphs and not more than 5 paragraphs
}

export enum Language {
  POLISH = 'pl',
  ENGLISH = 'en',
}

export enum FormControls {
  TYPE = 'type',
  STYLE = 'style',
  LENGTH = 'length',
  EMOJIS = 'emojis',
  LANGUAGE = 'language',
  MAIN_INFORMATION = 'mainInformation',
}